/* eslint-disable react-hooks/exhaustive-deps */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "~contexts/Auth";
import { ROLES } from "./constants";
import Common from "~components/Templates/Common";
import useLocalStorage from "~hooks/useLocalStorage";
import { AccessDenied } from "~components/Pages";

type PrivateRoutesProps = {
  noLayout?: boolean;
  roles: Array<ROLES>;
};

const PrivateRoutes = ({ roles, noLayout }: PrivateRoutesProps) => {
  const location = useLocation();
  const { signed, user } = useAuth();
  const [appToken] = useLocalStorage("@app:token", null);
  const userHasRequiredRole = user && !!roles.includes(user.role);

  if (!signed && !appToken) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Admin sempre tem acesso
  if (signed) {
    if (user?.role === ROLES.admin) {
      // Admin pode acessar tudo
    } else if (user?.role === ROLES.chat) {
      // return <Navigate to="/chat" state={{ from: location }} replace />;
    } else if (!userHasRequiredRole) {
      // Usuário não tem role necessário
      return <AccessDenied isSigned={true} />;
    }
  }

  if (noLayout) {
    return <Outlet />;
  }

  return (
    <Common>
      <Outlet />
    </Common>
  );
};

const PublicRoutes = () => {
  const location = useLocation();
  const [appToken] = useLocalStorage("@app:token", null);
  const { signed, user } = useAuth();

  if (signed && appToken && user) {
    // Redirecionar baseado no role - sempre começar pela home para admin e usuario
    if (user.role === ROLES.admin || user.role === ROLES.usuario) {
      return <Navigate to="/home" state={{ from: location }} replace />;
    } else if (user.role === ROLES.chat) {
      return <Navigate to="/chat" state={{ from: location }} replace />;
    }
  }

  return <Outlet />;
};

export { PrivateRoutes, PublicRoutes };
